import { FormGenericItemComponent } from '../../../../../shared/modules/configurable-form/components/form-generic-item/form-generic-item.component';
import { FieldConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-config.interface';
import { FieldLabelConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-label-config.interface';
import {
  OneClickPaymentProvider,
  OneClickHasResultProvider,
  OneClickNoResultProvider,
} from '../../../../providers/order/one-click-payment.provider';
import { OneClickProductProvider } from '../../../../providers/order/one-click-product.provider';
import { OneClickStandardLotProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-standard-lot.provider';
import { OneClickDeliveryMethodProvider } from '../../../../providers/order/one-click-delivery-method.provider';
import { OneClickPreviewField } from '../../../../util/constants/preview-fields';
import { OneClickLocationProvider } from '../../../../providers/order/one-click-location.provider';
import { OneClickLocationDisplayer } from '../../../../../../modules/one-click-order/providers/order/one-click-multiple-jobsite-displayer.provider';
import { FormSelectComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/form-select.component';
import { FieldSelectConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-multiselect/models/field-select-config.interface';
import { Validators } from '@angular/forms';
import { OneClickSetTimeWindow } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-time-window.command.service';
import { OneClickTimeWindowsEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-time-windows.effects';
import { OneClickPreviewTimeWindowLoadingProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-preview-time-windows-loading.provider';
import { OneClickTimeWindowDefaultMorningLoaderService } from '@ordersnproducts/modules/one-click-order/services/loaders/one-click-time-windows.loader.service';
import { OneClickTimeWindowProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-time-window.provider';
import { FormSeparatorComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-separator/form-separator.component';
import { OneClickMultipleOption } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-is-multiple-option.provider';
import { OneClickFeatureConfig } from '@ordersnproducts/modules/one-click-order/models/one-click-feature-config';
import { OneClickElement } from '@ordersnproducts/modules/one-click-order/util/enums/one-click-element';
import { OneClicTermsAndConditionsConfig } from '@ordersnproducts/modules/one-click-order/models/one-click-element-config';
import { FormTextAreaComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-textarea/form-textarea.component';
import { OneClickDeliveryInstructionsProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-delivery-instructions.provider';
import { OneClickSetDeliveryInstructionCommand } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-delivery-instruction.command.service';

export const preview: FieldConfig[] = [
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Jobsite,
    label: 'views.one_click.jobsite',
    hidden: OneClickLocationDisplayer.HideJobsite,
    text: OneClickLocationProvider.TextPreview,
    containerClassNames: ['col-12 mb-2 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagjobsite',
    dataTIdValue: 'cmx-createoneclickorder-lblvaljobsite',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.PointOfDelivery,
    label: 'views.one_click.pod',
    hidden: OneClickLocationDisplayer.HidePointOfDelivery,
    text: OneClickLocationProvider.TextPreview,
    containerClassNames: ['col-12 mb-2 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagpointofdelivery',
    dataTIdValue: 'cmx-createoneclickorder-lblvalpointofdelivery',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Product,
    text: OneClickProductProvider,
    label: 'views.one_click.product',
    dataTIdLabel: 'cmx-createoneclickorder-lbltagproduct',
    dataTIdValue: 'cmx-createoneclickorder-lblvalproduct',
    containerClassNames: ['col-md-6 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Quantity,
    text: OneClickStandardLotProvider,
    label: 'views.specifications.quantity',
    containerClassNames: ['col-md-3 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagquantity',
    dataTIdValue: 'cmx-createoneclickorder-lblvalquantity',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Payment,
    text: OneClickPaymentProvider,
    label: 'views.one_click.payment_method',
    dataTIdLabel: 'cmx-createoneclickorder-lbltagpayment',
    dataTIdValue: 'cmx-createoneclickorder-lblvalpayment',
    containerClassNames: ['col-md-3 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.DeliveryMethod,
    text: OneClickDeliveryMethodProvider.TextPreview,
    label: 'views.one_click.delivery_method',
    dataTIdLabel: 'cmx-createoneclickorder-lbltagdeliverymethod',
    dataTIdValue: 'cmx-createoneclickorder-lblvaldeliverymethod',
    containerClassNames: ['col-md-12 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormSelectComponent,
    name: OneClickPreviewField.TimeWindow,
    label: 'views.one_click.time_window',
    placeholder: 'views.one_click.select_time_window',
    optionsLoader: OneClickTimeWindowDefaultMorningLoaderService,
    loading: OneClickPreviewTimeWindowLoadingProvider,
    hidden: OneClickHasResultProvider,
    dynamicEffects: [OneClickTimeWindowsEffects],
    onChange: [OneClickSetTimeWindow],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagtimewindow',
    dataTIdValue: 'cmx-createoneclickorder-lblvaltimewindow',
    containerClassNames: ['col-md-4 mb-3 text-capitalize retail-control'],
    validation: [Validators.required],
  } as FieldSelectConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.TimeWindow,
    text: OneClickTimeWindowProvider,
    label: 'views.one_click.time_window',
    hidden: OneClickNoResultProvider,
    containerClassNames: ['col-md-6 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagtimewindow',
    dataTIdValue: 'cmx-createoneclickorder-lblvaltimewindow',
  } as FieldLabelConfig,
  {
    type: FormTextAreaComponent,
    label: 'views.one_cick.delivery_instructions',
    name: OneClickPreviewField.SpecialInstructions,
    onChange: [OneClickSetDeliveryInstructionCommand],
    hidden: OneClickHasResultProvider,
    containerClassNames: ['col-md-12 text-capitalize'],
    placeholder: 'views.one_click.enter_comments',
    maxlength: '500',
  } as FieldConfig,
  {
    type: FormGenericItemComponent,
    label: 'views.one_cick.delivery_instructions',
    text: OneClickDeliveryInstructionsProvider,
    name: OneClickPreviewField.SpecialInstructions,
    hidden: OneClickNoResultProvider,
    containerClassNames: ['col-md-12 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagdeliveryinstruction',
    dataTIdValue: 'cmx-createoneclickorder-lblvaldeliveryinstruction',
  } as FieldLabelConfig,
  {
    type: FormSeparatorComponent,
    name: '',
    containerClassNames: ['col-md-12'],
    hidden: OneClickHasResultProvider,
    visible: OneClickMultipleOption.IsSingleOption,
  } as FieldConfig,
];

export const features: OneClickFeatureConfig = {
  [OneClickElement.TERMS_AND_CONDITIONS]: {
    name: OneClickElement.TERMS_AND_CONDITIONS,
    checkByDefault: true,
  } as OneClicTermsAndConditionsConfig,
};
